import React from 'react';

import ReactDOM from 'react-dom';

import { App } from './app';

const root = document.getElementById('root');

export const mount = () => {
  if (!root) {
    console.error('Root element not found');
    return;
  }

  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    root,
  );
};
